(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vr-freebie-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-freebie')) {
    class VrFreebie extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.tiers = [1, 2, 3]
          .map((i) => ({ amt: (Number(d['t' + i + 'Amt']) || 0) * 100, label: d['t' + i + 'Label'] || '' }))
          .filter((t) => t.amt > 0 && t.label)
          .sort((a, b) => a.amt - b.amt);
        this.useCart = d.includeCart === 'true';
        this.cart = this.useCart ? Number(d.cartTotal) || 0 : 0;
        let list = [];
        try { list = JSON.parse(document.querySelector('script[data-vr-variants]').textContent); } catch (e) {}
        this.variant = list.find((v) => String(v.id) === d.variant) || null;
        this.style.setProperty('--vr-fb-n', this.tiers.length || 1);
        this.buildMarks();
        this.onVariant = (e) => { this.variant = e.detail; this.render(); };
        this.onCart = () => this.refreshCart();
        this.onQty = (e) => { if (e.target && e.target.name === 'quantity') this.render(); };
        this.onClick = (e) => { if (e.target.closest && e.target.closest('quantity-selector-component')) setTimeout(() => this.render(), 60); };
        document.addEventListener('vr:variant', this.onVariant);
        document.addEventListener('vr:cart', this.onCart);
        document.addEventListener('cart:update', this.onCart);
        document.addEventListener('input', this.onQty);
        document.addEventListener('change', this.onQty);
        document.addEventListener('click', this.onClick);
        this.render();
        if (this.useCart) this.refreshCart();
      }
      disconnectedCallback() {
        document.removeEventListener('vr:variant', this.onVariant);
        document.removeEventListener('vr:cart', this.onCart);
        document.removeEventListener('cart:update', this.onCart);
        document.removeEventListener('input', this.onQty);
        document.removeEventListener('change', this.onQty);
        document.removeEventListener('click', this.onClick);
      }
      money(c) {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: this.dataset.currency || 'INR', maximumFractionDigits: 0 }).format(Math.ceil(c / 100));
      }
      buildMarks() {
        const box = this.querySelector('.vr-freebie__marks');
        box.replaceChildren(...this.tiers.map((t) => {
          const m = document.createElement('div');
          m.className = 'vr-freebie__mark';
          const b = document.createElement('b');
          b.textContent = this.money(t.amt);
          const s = document.createElement('span');
          s.textContent = t.label;
          m.append(b, s);
          return m;
        }));
      }
      refreshCart() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => {
            // Free gifts are added as extra lines; they must not count towards the order value.
            this.cart = c.items.reduce((sum, i) => sum + (i.properties && i.properties._Freebie_for_variant ? 0 : i.final_line_price), 0);
            this.render();
          })
          .catch(() => {});
      }
      qty() {
        const q = document.querySelector('#MainContent form[action*="/cart/add"] input[name="quantity"]');
        return Math.max(1, parseInt(q && q.value, 10) || 1);
      }
      fill(parts, tpl, map) {
        const out = [];
        tpl.split(/(\[remaining\]|\[reward\]|\[unlocked\])/).forEach((p) => {
          const m = p.match(/^\[(remaining|reward|unlocked)\]$/);
          if (m) { const b = document.createElement('b'); b.textContent = map[m[1]]; out.push(b); }
          else if (p) out.push(document.createTextNode(p));
        });
        parts.push(...out);
      }
      render() {
        const d = this.dataset;
        const T = this.tiers;
        if (!this.variant || !T.length) { this.hidden = true; return; }
        this.hidden = false;
        // Order value = selected variant x quantity (+ items already in the cart, gifts excluded).
        const total = this.variant.price * this.qty() + this.cart;
        const k = T.filter((t) => total >= t.amt).length; // tiers unlocked so far
        const prev = k ? T[k - 1] : null;
        const next = T[k] || null;
        const parts = [];
        const icon = d.icon ? d.icon + ' ' : '';
        let pct = 100;
        if (!next) {
          this.fill(parts, icon + d.textDone, { reward: T[T.length - 1].label, unlocked: T[T.length - 1].label, remaining: '' });
        } else {
          // Every reward owns an equal part of the bar, so the fill always lines up with the markers below it.
          const from = prev ? prev.amt : 0;
          pct = ((k + (total - from) / (next.amt - from)) / T.length) * 100;
          pct = Math.max(3, Math.min(100, pct));
          const map = { remaining: this.money(next.amt - total), reward: next.label, unlocked: prev ? prev.label : '' };
          this.fill(parts, icon + (prev ? d.textNext : d.textProgress), map);
          if (d.hint) parts.push(document.createTextNode(' ' + d.hint));
        }
        this.querySelector('.vr-freebie__msg').replaceChildren(...parts);
        this.querySelectorAll('.vr-freebie__mark').forEach((m, i) => m.classList.toggle('is-on', i < k));
        const track = this.querySelector('.vr-freebie__track');
        track.setAttribute('aria-valuenow', Math.round(pct));
        requestAnimationFrame(() => { this.querySelector('.vr-freebie__fill').style.width = pct + '%'; });
      }
    }
    customElements.define('vr-freebie', VrFreebie);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vr-per-day"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-perday')) {
    class VrPerDay extends HTMLElement {
      connectedCallback() {
        this.onVariant = (e) => this.render(e.detail);
        document.addEventListener('vr:variant', this.onVariant);
      }
      disconnectedCallback() {
        document.removeEventListener('vr:variant', this.onVariant);
      }
      render(v) {
        const d = this.dataset;
        let units = 1;
        if (d.unitsFromOption === 'true') {
          for (const o of v.options.join(' ').split(' ')) {
            if (/^\d+$/.test(o) && +o > 0) { units = +o; break; }
          }
        }
        const grams = +d.grams || 0;
        const perUse = +d.perUse || 0;
        if (!grams || !perUse || !v.price) { this.hidden = true; return; }
        const usesTotal = (grams * units) / perUse;
        let days = Math.floor(usesTotal);
        if (days >= 100) days = Math.floor(days / 10) * 10;
        const c = v.price / 100 / usesTotal;
        const cost = d.symbol + (c >= 10 ? Math.round(c) : Math.round(c * 10) / 10);
        this.hidden = false;
        this.querySelector('.vr-perday__text').textContent = d.text
          .replace(/\[days\]/g, days)
          .replace(/\[per_use\]/g, d.perUseText)
          .replace(/\[grams\]/g, grams)
          .replace(/\[cost_per_use\]/g, cost)
          .replace(/\[units\]/g, units);
      }
    }
    customElements.define('vr-perday', VrPerDay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vr-prepaid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vr-prepaid')) {
    class VrPrepaid extends HTMLElement {
      connectedCallback() {
        this.onVariant = (e) => this.render(e.detail);
        document.addEventListener('vr:variant', this.onVariant);
      }
      disconnectedCallback() {
        document.removeEventListener('vr:variant', this.onVariant);
      }
      render(v) {
        const d = this.dataset;
        const pct = +d.percent || 0;
        const rupees = Math.round((v.price * (100 - pct)) / 10000);
        if (!pct || !rupees) { this.hidden = true; return; }
        this.hidden = false;
        const money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: d.currency || 'INR', maximumFractionDigits: 0 }).format(rupees);
        const out = this.querySelector('.vr-prepaid__text');
        out.replaceChildren();
        d.text.replace(/\[percent\]/g, pct).split('[amount]').forEach((part, i) => {
          if (i) { const b = document.createElement('b'); b.textContent = money; out.append(b); }
          out.append(document.createTextNode(part));
        });
      }
    }
    customElements.define('vr-prepaid', VrPrepaid);
  }
  } catch(e) { console.error(e); }
})();

})();
